<template>
  <div id="content" class="text-left">
    <h1>Mon diagnostic gaspillage</h1>
    <v-form ref="form" v-model="formIsValid" id="diagnostic-form" @submit.prevent class="mb-4">
      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Avez-vous mesuré le gaspillage alimentaire dans votre cantine ?</h2>
          <DsfrRadio
            v-model="diagnostic.foodWasteMeasurement"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
            @click="isFirstDiagDone"
            required
          />
        </v-col>
      </v-row>

      <!-- <v-row class="mt-2" v-if="diagnostic.foodWasteMeasurement === 'Oui '">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Quel est le pourcentage de gaspillage alimentaire mesuré ?</h2>
          <DsfrTextField
            v-model.number="diagnostic.wastePercentage"
            label="Entrez le pourcentage"
            append-icon="mdi-percent"
            :rules="[validators.isPercentageOrEmpty]"
            class="text-left"
            required
          />
        </v-col>
      </v-row> -->

      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">Avez-vous mis en place un plan de réduction du gaspillage alimentaire ?</h2>
          <DsfrRadio
            v-model="diagnostic.wasteReductionPlan"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
            @click="isFirstDiagDone"
            required
          />
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12">
          <h2 class="mb-2 text-left">
            Avez-vous mené des actions de sensibilisation contre le gaspillage alimentaire ?
          </h2>
          <DsfrRadio
            v-model="diagnostic.awarenessActions"
            :items="[
              { value: 'Oui', label: 'Oui' },
              { value: 'Non', label: 'Non' },
            ]"
            label="Sélectionnez une option"
            hide-details
            class="text-left"
            @click="isFirstDiagDone"
            required
          />
        </v-col>
      </v-row>

      <v-row>
        <v-btn
          v-if="isFirstDiagDone"
          large
          color="primary"
          @click="goToNextDiagnostic"
          :disabled="!formIsValid"
          class="my-8"
        >
          Passer au second diagnostic
        </v-btn>
        <v-btn v-else large color="primary" @click="gotToFirstDiagnostic" :disabled="!formIsValid" class="my-8">
          Passer au premier diagnostique
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import DsfrRadio from "@/components/DsfrRadio"
import validators from "@/validators"

export default {
  name: "WasteDiagnosticPage",
  components: {
    DsfrRadio,
  },
  data() {
    return {
      diagnostic: {
        foodWasteMeasurement: "",
        // wastePercentage: null,
        wasteReductionPlan: "",
        awarenessActions: "",
      },
    }
  },
  methods: {
    goToNextDiagnostic() {
      console.log("On passe au diag 2", this.diagnostic)
    },
    gotToFirstDiagnostic() {
      console.log("On passe au 1er diag", this.diagnostic)
      this.$router.push("/diagnostic-1")
    },
  },
  computed: {
    validators() {
      return validators
    },
    isFirstDiagDone() {
      return !Object.values(this.diagnostic).some((value) => typeof value === "string" && value.toLowerCase() === "non")
    },
    formIsValid() {
      return Object.values(this.diagnostic).every((value) => value !== "" && value !== null && value !== undefined)
    },
  },
}
</script>

<style scoped>
#content {
  width: 210mm;
}

#diagnostic-form {
  display: flex;
  flex-direction: column;
  align-items: left;
  max-width: 1500px !important;
  margin: auto;
}

::v-deep span.fr-hint-text {
  display: none !important;
}

h2 {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.text-left {
  text-align: left;
}

@media (max-width: 210mm) {
  #content {
    width: 100%;
  }
}
</style>
